import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import sensors from "@/plugins/sa" 
import useClickId from './useClickId'

const useTrack = () => {
  const route = useRoute()
  const store = useStore()
  const userInfo = computed(() => store.state.userInfo)
  const commonDsl = computed(() => store.state.dslData.commonDsl)
  const currentPageDsl = computed(() => store.state.currentPageDsl)
  const { bid, clickId } = useClickId()

  const pageTypeMap = {
    spread: 0,
    //  basic: 1
    wxBasic: 1
  }

  const appPlatformMap = {
    jfzgApp: 'com.rjhy.jupiter',
    hxgApp: 'com.baidao.silver',
    jfqlApp: 'com.rjhy.uranus',
    'com.rjhy.uranus': 'com.rjhy.uranus'
  }
  
  const getCommonProperties = () => {
    const { pageType, id, subId } = route.params
    return {
      source: route.query?.source || commonDsl.value?.source,
      public_channel: route.query?.publicChannel || commonDsl.value?.publicChannel,
      mainpage_id: id,
      zipage_id: subId,
      bid: bid.value,
      account_id: route.query?.accountId || commonDsl.value?.accountId,
      union_id: userInfo.value?.unionid,
      channel_id: route.query?.channel_id,
      title: currentPageDsl.value?.pageTitle,
      clickid: clickId.value,
      url: window.location.href,
      page_type: pageTypeMap[pageType],
      project_id: appPlatformMap[commonDsl.value?.appPlatform],
      username: userInfo.value?.username || userInfo.value?.userData?.username || route.query.username,
    }
  }

  const upstreamProperties = () => {
    return {
      landkingkey: route.query.landkingkey,
      oaid: route.query.oaid,
    }
  }

  const track = (event, properties) => {
    const { id } = route.params
    // 如果是预览模式 那么就不打埋点
    if (id === 'preview' || route.query?.preview) return

    sensors.track(event, {
      ...getCommonProperties(),
      ...upstreamProperties(),
      ...properties,
    })
  }
  
  return {
    track
  }
}

export default useTrack